<template>
  <div class="awardsList" v-if="awardsList">
    <AwardItem
      v-for="awardData in awardsList"
      :awardData="awardData"
      :key="awardData.id"
      :actEndTimeStr="actEndTimeStr"
      :isHasUserAddress="isHasUserAddress"
    />
    <div class="empty" v-if="!awardsList.length">
      <div class="icon"></div>
      <div>{{ $t('my_awards.no_awards') }}</div>
    </div>
    <div class="noMore" v-if="awardsList.length">
      {{ $t('my_awards.no_more') }}
    </div>
  </div>
</template>

<script>
import AwardItem from './AwardItem';
import { mapState, mapGetters } from 'vuex';
import { formatTime } from '@/utils';

export default {
  components: { AwardItem },
  computed: {
    ...mapState('app/myAwards', {
      awardsList: state => state.awardsList
    }),
    actEndTimeStr() {
      return formatTime('M月d日', this.getActEndTime() / 1000);
    },
    isHasUserAddress() {
      return this.checkIsHasUserAddress();
    }
  },
  methods: {
    ...mapGetters('app/lottery', ['getActEndTime']),
    ...mapGetters('app/myAwards', ['checkIsHasUserAddress'])
  }
};
</script>

<style lang="less" scoped>
.awardsList {
  box-sizing: border-box;
  padding: 24px;
  width: 100%;

  .empty {
    margin-top: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 30px;
    color: #8c8c8c;

    .icon {
      margin-bottom: 107px;
      width: 287px;
      height: 185px;
      background: center / cover no-repeat url('../../assets/images/empty.png');
    }
  }

  .noMore {
    margin: 30px 0;
    text-align: center;
    font-size: 30px;
    color: #8c8c8c;
  }
}
</style>
